import ShareModalWrapper from './ShareModalWrapper';

export default ShareModalWrapper;
